import request from '../../../../api/request';
import { StudentSessionDetailResponse, UpdateSessionFormFields } from './types';

export const CEIA = {
  GET_STUDENT_SESSION_DATA: (id: string) =>
    `/maintainers-portal/student-risk-evaluation-session/detail/${id}`,
  UPDATE_STUDENT_SESSION_ENROLLMENT: (id: number) =>
    `/maintainers-portal/student-risk-evaluation-session/detail/enrollment/${id}`,
};

export function getStudentSessionDetail(id: string) {
  return request<StudentSessionDetailResponse>(
    CEIA.GET_STUDENT_SESSION_DATA(id),
  );
}

export function updateStudentSessionEnrollment(
  id: number,
  data: UpdateSessionFormFields,
) {
  return request<StudentSessionDetailResponse>(
    CEIA.UPDATE_STUDENT_SESSION_ENROLLMENT(id),
    {
      method: 'PUT',
      data,
    },
  );
}
